import { Injectable } from '@angular/core';

export interface CustomError {
  error?: {
    error?: {
      code?: string;
      details?: {msg: string; path: string; type?: string; value?: any}[] | { errors?: {msg: string; path: string}[] };
      message?: string;
    },
    message?: string;
  },
  message?: string;
  status?: number;
  statusText?: string;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorMessageService {

  constructor() { }

  static extract(error: CustomError) {
    if(!error) {return '';}

    let code = error?.error?.error?.code ||
      error?.error?.message ||
      error?.statusText ||
      error?.status;

    let message =  error?.error?.error?.message ||
      error?.error?.message ||
      error?.message ||
      error?.statusText;

    if(this.hasRecaptchaError(error)) {
      let msg = 'A recaptcha error occurred. Pleae reload the application or check your internet connection.';
      return msg;
    }

    const details = this.validationDetails(error);

    switch(code) {
      case 'INVALID_CREDENTIALS_SUPPLIED':
        return 'An invalid email and password combination was presented.';
      case 'VALIDATION_ERROR':
        if(message && ['LOGIN_FAILED'].indexOf(message) != -1) {
          return 'An invalid email and password combination was presented.';
        }
        message = 'VALIDATION ERROR';
        message+= !details.length ? '' :
          ': ' + details.map(detail => {
            return detail.path + ': ' + detail?.msg;
          }).join('. ');
        return message;
    }
    if (details.length) {
      return details.map(detail => detail?.msg).filter(Boolean).join('. ');
    }
    return message?.replaceAll('_', ' ');
  }

  static validationDetails(error: CustomError): {msg: string; path: string; type?: string; value?: any}[] {
    const details = error?.error?.error?.details as {msg?: string; path?: string; errors?: {msg: string; path: string}[]} | {msg: string; path: string}[] | undefined;
    if (Array.isArray(details)) {
      return details;
    }
    if (details && Array.isArray(details.errors)) {
      return details.errors;
    }
    return [];
  }

  static hasRecaptchaError(error: CustomError) {
      return this.validationDetails(error).some(detail => detail.path == 'recaptcha');
  }
}
